@if (isLoading()) {
<ul class="ai-product-cards" aria-busy="true" aria-label="Loading products">
  @for (index of skeletons; track index) {
  <li class="ai-product-card is-skeleton" aria-hidden="true">
    <span class="ai-product-card-image"></span>
    <span class="ai-product-card-name"></span>
  </li>
  }
</ul>
} @else if (cards().length) {
<p class="ai-product-cards-label" id="{{ labelId }}">{{ holdsRecommended ? 'Products in this reply' : 'Also mentioned' }}</p>
<ul class="ai-product-cards" [attr.aria-labelledby]="labelId">
  @for (card of cards(); track $index) {
  <li class="ai-product-card">
    <a class="ai-product-card-link" [routerLink]="card.url">
      <img class="ai-product-card-image" [src]="card.image_url" alt="" width="148" height="148"
        loading="lazy" appHandleImageError>
      <span class="ai-product-card-name">{{ card.name }}</span>
      @if (card.recommended) {
      <span class="ai-product-card-badge">Recommended</span>
      }
    </a>
  </li>
  }
</ul>
}
